module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [(!_vm.editTopicName) ? _c('h1', [_vm._v("\n      Topic: " + _vm._s(this.$route.query.topic_name) + "   "), _c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": this.onEditTopicName
    }
  }), _vm._v("  \n    ")]) : _vm._e(), _vm._v(" "), (_vm.editTopicName) ? _c('form', {
    style: ({
      width: '30%',
      display: 'flex',
      'justify-content': 'space-between',
      'align-items': 'center'
    }),
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateTopicOrPrompt.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topicName),
      expression: "topicName"
    }],
    style: ({
      width: '80%'
    }),
    attrs: {
      "type": "text",
      "placeholder": this.$route.query.topic_name,
      "required": ""
    },
    domProps: {
      "value": (_vm.topicName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.topicName = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": this.onEditTopicName
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('form', {
    staticStyle: {
      "dispay": "flex"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateTopicOrPrompt.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group col-xs-5 col-sm-5 col-md-5"
  }, [_c('label', {
    attrs: {
      "for": "Prompt"
    }
  }, [_vm._v("Prompt")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "id": "topic",
      "placeholder": "--Choose NLP Topic--",
      "multiple": false,
      "options": _vm.promptList
    },
    model: {
      value: (_vm.promptId),
      callback: function($$v) {
        _vm.promptId = $$v
      },
      expression: "promptId"
    }
  })], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('button', {
    staticClass: "action-btn action-btn-save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addLabelMapping
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Add New Label Mapping\n          ")])])])]), _vm._v(" "), (_vm.pageLoading) ? _c('div', {
    attrs: {
      "aria-busy": "true",
      "aria-label": "Loading mappings"
    }
  }, _vm._l((3), function(n) {
    return _c('div', {
      key: 'skeleton-' + n,
      staticClass: "panel panel-default mapping-card skeleton-card"
    }, [_vm._m(3, true)])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.pageLoading) ? [_vm._l((_vm.mappingList), function(item, index) {
    return _c('div', {
      key: index,
      ref: "mappingCards",
      refInFor: true
    }, [_c('div', {
      staticClass: "panel panel-default mapping-card",
      class: {
        'wormhole-panel': item.hasAdditionalConfig
      }
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-xs-12 keyword-conversation-container"
    }, [_c('div', {
      staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
    }, [_c('label', {
      staticClass: "required",
      attrs: {
        "for": "label"
      }
    }, [_vm._v("Label\n                  ")]), _vm._v(" "), _c('treeselect', {
      attrs: {
        "placeholder": "--Choose or Enter label--",
        "multiple": false,
        "defaultOptions": true,
        "load-options": _vm.loadOptions,
        "async": true,
        "id": "referral_source",
        "search-nested": "",
        "cacheOptions": false
      },
      on: {
        "select": _vm.addNewSource
      },
      scopedSlots: _vm._u([{
        key: "value-label",
        fn: function(ref) {
          var node = ref.node;

          return _c('div', {}, [_vm._v(_vm._s(node.raw.customLabel))])
        }
      }], null, true),
      model: {
        value: (item.label),
        callback: function($$v) {
          _vm.$set(item, "label", $$v)
        },
        expression: "item.label"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-3 col-sm-3 col-md-3"
    }, [_c('label', {
      staticClass: "required"
    }, [_vm._v("Conversation")]), _vm._v(" "), _c('treeselect', {
      attrs: {
        "placeholder": "--Choose a conversation--",
        "multiple": false,
        "options": _vm.conversationList
      },
      on: {
        "select": function (node, id) { return _vm.selectConversation(node, index); },
        "input": function (node, id) { return _vm.updateStageList(node, index); }
      },
      model: {
        value: (item.conversation_id),
        callback: function($$v) {
          _vm.$set(item, "conversation_id", $$v)
        },
        expression: "item.conversation_id"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-3 col-sm-3 col-md-3"
    }, [_c('label', {
      staticClass: "nlp-convo-exit-mapping-label"
    }, [_vm._v("Stage of Conversation")]), _vm._v(" "), _c('treeselect', {
      attrs: {
        "placeholder": "--Choose a stage--",
        "multiple": false,
        "options": item.stageList
      },
      model: {
        value: (item.additional_topic_mapping_details.stage),
        callback: function($$v) {
          _vm.$set(item.additional_topic_mapping_details, "stage", $$v)
        },
        expression: "item.additional_topic_mapping_details.stage"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2 mapping-actions"
    }, [_c('button', {
      staticClass: "action-btn action-btn-save",
      class: {
        'action-btn-dirty': _vm.isDirty(item)
      },
      attrs: {
        "type": "button",
        "title": _vm.isDirty(item) ? 'You have unsaved changes. Click to save' : 'Save this mapping'
      },
      on: {
        "click": function($event) {
          return _vm.saveMapping(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Save\n                ")]), _vm._v(" "), _c('button', {
      staticClass: "action-btn action-btn-icon action-btn-delete",
      attrs: {
        "type": "button",
        "title": "Delete this mapping"
      },
      on: {
        "click": function($event) {
          return _vm.removeMapping(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('div', {
      staticClass: "mapping-footer"
    }, [_c('div', {
      staticClass: "exit-mapping-summary"
    }, [_c('span', {
      staticClass: "exit-mapping-title"
    }, [_vm._v("End stage")]), _vm._v(" "), (_vm.exitMappingsFor(item).length) ? _vm._l((_vm.exitMappingsFor(item)), function(exit, exitIndex) {
      return _c('span', {
        key: exitIndex,
        staticClass: "exit-chip",
        attrs: {
          "title": exit.conversation + ' → ' + exit.stage
        }
      }, [_c('span', {
        staticClass: "exit-chip-convo"
      }, [_vm._v(_vm._s(exit.conversation))]), _vm._v(" "), _c('i', {
        staticClass: "fa fa-long-arrow-right",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "exit-chip-stage"
      }, [_vm._v(_vm._s(exit.stage))])])
    }) : _c('span', {
      staticClass: "exit-mapping-empty"
    }, [_vm._v("Not set")]), _vm._v(" "), _c('button', {
      staticClass: "action-btn action-btn-edit",
      attrs: {
        "type": "button",
        "title": "Edit end stage mappings"
      },
      on: {
        "click": function($event) {
          return _vm.showAddConversationMappingModal(index, item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Edit\n              ")])], 2), _vm._v(" "), _c('div', {
      staticClass: "mapping-options"
    }, [(_vm.isDirty(item)) ? _c('span', {
      staticClass: "unsaved-badge"
    }, [_c('i', {
      staticClass: "fa fa-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Unsaved changes")]) : _c('span', {
      staticClass: "saved-badge"
    }, [_c('i', {
      staticClass: "fa fa-check-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Saved")]), _vm._v(" "), _c('label', {
      staticClass: "switch-option",
      attrs: {
        "title": "When on, the bot skips the preamble message and sends the answer or conversation directly"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.additional_topic_mapping_details.skip_preamble),
        expression: "item.additional_topic_mapping_details.skip_preamble"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.additional_topic_mapping_details.skip_preamble) ? _vm._i(item.additional_topic_mapping_details.skip_preamble, null) > -1 : (item.additional_topic_mapping_details.skip_preamble)
      },
      on: {
        "change": function($event) {
          var $$a = item.additional_topic_mapping_details.skip_preamble,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item.additional_topic_mapping_details, "skip_preamble", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item.additional_topic_mapping_details, "skip_preamble", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item.additional_topic_mapping_details, "skip_preamble", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _c('span', {
      staticClass: "switch-text switch-text-primary"
    }, [_vm._v("Skip preamble message")])]), _vm._v(" "), _c('label', {
      staticClass: "switch-option",
      attrs: {
        "title": "Also clear cached chatbot responses for this topic's conversations when you save"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.invalidateCache),
        expression: "item.invalidateCache"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.invalidateCache) ? _vm._i(item.invalidateCache, null) > -1 : (item.invalidateCache)
      },
      on: {
        "change": function($event) {
          var $$a = item.invalidateCache,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "invalidateCache", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "invalidateCache", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "invalidateCache", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _c('span', {
      staticClass: "switch-text"
    }, [_vm._v("Invalidate cache")])])])])])])])
  }), _vm._v(" "), _c('button', {
    staticClass: "add-mapping-bottom",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addLabelMapping
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Add New Label Mapping\n    ")])] : _vm._e()], 2), _vm._v(" "), (_vm.isDeleteConfirmationVisible) ? _c('deleteConfirmationModal', {
    attrs: {
      "isDeleteConfirmationVisible": _vm.isDeleteConfirmationVisible,
      "confirmationMessage": _vm.confirmationMessage,
      "actionToBePerformed": _vm.actionToBePerformed
    },
    on: {
      "close": _vm.closeConfirmationModal,
      "deleteMappingFromDB": _vm.deleteMappingFromDB
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNlpConversationExitMappingVisible) ? _c('NlpConversationExitMapping', {
    attrs: {
      "isNlpConversationExitMappingVisible": _vm.isNlpConversationExitMappingVisible,
      "conversationList": _vm.conversationList,
      "labelMappingId": _vm.currentSelectedMapping,
      "conversationExitMapping": _vm.selectedConversationExitMapping,
      "additionalTopicMappingDetails": _vm.selectedAdditionalTopicMapping
    },
    on: {
      "close": _vm.closeExitMappingModal,
      "updateConversationExitMapping": _vm.updateConversationExitMapping
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-primary col-xs-2 col-sm-2 col-md-2 col-2",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v(" NLP Topic-Label-Conversation Mappings")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "nlp_topic_list"
    }
  }, [_vm._v(" Mapping List")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Mapping Detail")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-rounded btn-remove-nudge btn-nudge margin-top-30 btn-primary col-xs-2 col-sm-2 col-md-2 col-2",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "skeleton-fields"
  }, [_c('div', {
    staticClass: "skeleton-field skeleton-field-wide"
  }, [_c('div', {
    staticClass: "sk sk-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk sk-input"
  })]), _vm._v(" "), _c('div', {
    staticClass: "skeleton-field"
  }, [_c('div', {
    staticClass: "sk sk-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk sk-input"
  })]), _vm._v(" "), _c('div', {
    staticClass: "skeleton-field"
  }, [_c('div', {
    staticClass: "sk sk-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk sk-input"
  })]), _vm._v(" "), _c('div', {
    staticClass: "skeleton-actions"
  }, [_c('div', {
    staticClass: "sk sk-button"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk sk-button-icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mapping-footer skeleton-footer"
  }, [_c('div', {
    staticClass: "sk sk-chip"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk sk-toggles"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "switch-track"
  }, [_c('span', {
    staticClass: "switch-thumb"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "switch-track"
  }, [_c('span', {
    staticClass: "switch-thumb"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-882416fa","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nlp-topic-mapping/nlpTopicMappingDetails.vue
// module id = ouf8
// module chunks = 1